import React, { useEffect, useState } from 'react'
import FinePaymentInformationView from './components/FinePaymentInformationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const FinePaymentInformation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('fine-payment-information', 'Pay a Fine', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <FinePaymentInformationView setIsError={setIsError} />
}

export default withTranslation('common')(FinePaymentInformation)
